import UrlParser from 'url-parse';

/**
 * @name getQueryValue
 * @description Get a query parameter value from a url string
 */
export const getQueryValue = (url: string, query: string): string | null => {
  /**
   * @see https://github.com/unshiftio/url-parse
   */
  const parsedUrl = new UrlParser(url, '/', true);

  return parsedUrl.query[query] || null;
};
